import React from "react"
import { formatDateTime } from "date_helpers"

export const STATUS_COLORS = {
  pending: "is-info",
  delivered: "is-success",
  failed: "is-warning",
  exhausted: "is-danger",
}

export const StatusTag = ({ status }) => (
  <span className={`tag ${STATUS_COLORS[status] || "is-light"}`}>{status}</span>
)

export const EndpointStatusTag = ({ endpoint }) => {
  if (endpoint.active) return <span className="tag is-success">Active</span>
  if (endpoint.disabledAt) return <span className="tag is-danger">Disabled by Catch</span>
  return <span className="tag is-light">Inactive</span>
}

export const formatTime = (value) => (value ? formatDateTime(value) : "Never")

export const copyText = (text, label = "Copied to clipboard") => {
  if (navigator.clipboard) navigator.clipboard.writeText(text)
  alert(label)
}
